<template>

    <div class="modal fade" :id="'popUpContenuto'+rs" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-xl"> 
            <div class="modal-content" >
                <div class="modal-header bg-secondary text-white border-0">
					<h5 class="modal-title">
						<i class="ph-list icon-modal-size me-2"></i><span class="me-2">Scheda:</span>{{contenutoLangSelezionato.TITOLO}}
					</h5>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
                </div>
                <div class="modal-body p-2" style="height: 33rem;"> 
              
                    <div class="card card-noshadow mb-0">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-2 col-lg-2">
		                            <div class="sidebar-content">
		                                <div class="card sidebar-section-body text-center p-2 mb-0">
		                                    <div class="card-img-actions d-inline-block">
		                                        <img v-if="contenuto.ID_CONTENUTO > 0 && contenuto.URL_AVATAR != 'placeholder.jpg'" :src="filters.getImgPath('CONTENUTO',contenuto.URL_AVATAR)" class="img-fluid squared-circle rounded-0" alt="" width="215" style="max-height: 230px;" />
		                                        <span v-if="contenuto.URL_AVATAR == 'placeholder.jpg' || contenuto.ID_CONTENUTO == 0">
		                                            <img src="../assets/images/placeholders/placeholder.jpg" class="img-fluid rounded-circle" width="150" height="150" alt="">
		                                        </span>
		                                        <div class="card-img-actions-overlay card-img rounded-circle">
		                                            <a href="#" class="btn btn-outline-white btn-icon rounded-pill" v-on:click="openUploadContenuto(this.contenuto)">
		                                                <i class="ph-pencil"></i>
		                                            </a>
		                                        </div>
		                                    </div>
		                                </div>

		                                <ul class="nav nav-sidebar" role="tablist">
		                                    <li v-if="modalita == 1" class="nav-item" role="presentation">
		                                        <a href="#cont-main" id="cont-main-tab" class="nav-link active" data-bs-toggle="tab" aria-selected="true" role="tab" style="padding-left: 5px;" tabindex="1">
				                                    <i class="ph-info me-2"></i>Info Contenuto
				                                </a> 
		                                    </li>
		                                    <li v-if="modalita == 2" class="nav-item" role="presentation">
		                                        <a href="#cont-main-cat" id="cont-main-cat-tab" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" style="padding-left: 5px;" tabindex="2">
				                                    <i class="ph-gauge me-2"></i>Info Categoria
				                                </a> 
		                                    </li>
		                                    <li class="nav-item" role="presentation">
		                                        <a href="#cont-seo" id="cont-seo-tab" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" style="padding-left: 5px;" tabindex="4">
				                                    <i class="ph-globe me-2"></i>Seo 
				                                </a>
		                                    </li>
			                            </ul>
                        			</div>

								</div>
                                <div class="col-12 col-md-10 col-lg-10">
			                        <div class="tab-content flex-fill">
			
			                            <div v-if="modalita == 1" class="tab-pane fade active show" id="cont-main" role="tabpanel">
			                                <h5 class="label-bar"><i class="fad fa-info-square fa-fw me-1"></i> Info Generali</h5>
						                    <div class="box_26"> 
			
			                                    <div class="row mt-1">
			                                        <div class="col-6 col-md-3 mb-2" v-if="soloManuale">
														<label class="form-label text-danger mb-1">Modulo</label>
														<span class="float-end" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Modulo operativo del contenuto" data-bs-original-title="Popover title"><i class="far fa-info-circle text-primary"></i></span>
			                                            <select v-if="contenuto.ID_CONTENUTO == 0" class="form-select form-select-sm" v-model="contenuto.FK_ID_MODULO">
			                                                <option value="">Seleziona modulo</option>
			                                                <option v-for="modulo in arrayModuliOperativi" v-bind:key="modulo.ID_OPZIONE_TIPOLOGICA" v-bind:value="modulo.ICONA"> &nbsp; {{modulo.DESCRIZIONE}}</option>
			                                            </select>
			                                            <input v-else type="text" class="form-control form-control-sm" :value="moduloOperativoLabel" disabled />
													</div>
			                                        <div class="col-6 col-md-3 mb-2" v-if="soloManuale">
														<label class="form-label text-danger mb-1">Categoria principale</label>
														<span class="float-end" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Categoria principale dell'articolo" data-bs-original-title="Popover title"><i class="far fa-info-circle text-primary"></i></span>
			                                            <select class="form-select form-select-sm" v-model="categoriaPrincipale">
			                                                <option value="0">Seleziona categoria</option>
			                                                <option v-for="cat in arrayCategoriePrincipali" v-bind:key="cat.ID_CATEGORIA" v-bind:value="cat.ID_CATEGORIA" >{{cat.DESCRIZIONE}}</option>
			                                            </select>
													</div>
			                                        <div class="col-6 col-md-3 mb-2" v-if="soloManuale">
														<label class="form-label mb-1">Altre categorie</label>
														<span class="float-end" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Categorie aggiuntive dell'articolo" data-bs-original-title="Popover title"><i class="far fa-info-circle text-primary"></i></span>
			                                            <Multiple class="w-88" v-bind:options="filters.toSelect2(arrayCategorieAggiuntive,'ID_CATEGORIA','DESCRIZIONE')" v-model="categorieAggiuntive"></Multiple>
													</div>
			                                        <div class="col-6 col-md-3 mb-2" v-else>
														<label class="form-label text-danger mb-1">Categoria</label>
														<span class="float-end" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Tematiche associate" data-bs-original-title="Popover title"><i class="far fa-info-circle text-primary"></i></span>
			                                            <select class="form-select form-select-sm" v-model="categoriaContenutoSelezionata">
			                                                <option value="0">Tutti</option>
			                                                <option v-for="cat in arrayCategorieSelezionabili" v-bind:key="cat.ID_CATEGORIA" v-bind:value="cat.ID_CATEGORIA" >{{cat.DESCRIZIONE}}</option>
			                                            </select>					                                        
													</div>
			                                        <div class="col-6 col-md-3 mb-2">
			                                            <label class="form-label text-danger mb-1">Modello Contenuto</label>	
			                                            <span class="float-end cursor-pointer" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Modello Contenuto"><i class="far fa-info-circle text-primary"></i></span>
			                                            <select class="form-select form-select-sm" v-model="contenuto.FK_ID_MODELLO">
			                                                <option value="">Tutti</option>
			                                                <option v-for="model in $root.arrayTipoContenuto" v-bind:key="model.ID_OPZIONE_TIPOLOGICA"  v-bind:value="model.ID_OPZIONE_TIPOLOGICA" >{{model.DESCRIZIONE}}</option>
			                                            </select>  
			                                        </div>
												</div>
												<div class="row mt-1">
			                                        <div class="col-6 col-md-9 mb-2">
			                                            <label class="form-label text-danger mb-1">Titolo:</label>
			                                            <div class="input-group">
			                                                <span class="input-group-text"><i class="far fa-tag fa-fw"></i></span>
			                                                <input autocomplete="off" type="text" class="form-control form-control-sm valid" placeholder="Descrizione" v-model="contenutoLangSelezionato.TITOLO" :tabindex="4">
			                                            </div>
			                                        </div>
												</div>
			
			                                    <div class="row mt-2">	
			                                        <div class="col-12 col-md-6">
			
			                                            <div class="row">
					                                        <div class="col-12 col-md-12 mb-2"> 
					                                            <label class="form-label mb-1">Slogan:</label>
					                                            <div class="input-group">
			                                                        <span class="input-group-text"><i class="far fa-user fa-fw"></i></span>
					                                                <input autocomplete="off" type="text" class="form-control form-control-sm" v-model="contenutoLangSelezionato.SOTTOTITOLO" :tabindex="4">
					                                            </div>
					                                        </div>
			                                                <div class="col-md-12 mb-2">

															</div>	 
			                                                <div class="col-md-12 mb-2">
			                                                    <label class="form-label text-danger mb-1">Pubblica sul Sito</label>
			                                                    <span class="float-end" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Pubbica su quale sito"><i class="far fa-info-circle text-primary"></i></span>
			                                                    <div class="input-group input-group-sm" :tabindex="15">
			                                                    	<span class="input-group-text cursor-pointer" v-on:click="contenuto.enti = filters.select2AddAll(contenuto.enti,filters.toSelect2($root.arrayEnti,'ID_ENTE','LABEL'))">Tutti</span>
			                                                        <Multiple class="w-88" v-bind:options="filters.toSelect2($root.arrayEnti,'ID_ENTE','LABEL')" v-model="contenuto.enti"></Multiple>
			                                                    </div>
			
			                                                </div>  
			                                    		</div>
			
			                                		</div>
			                                        <div class="col-12 col-md-6" style="border-left: 1px solid #ddd;">
			                                            
			                                            <div class="row">
			                                                <div class="col-12 col-md-12 mb-2">
			                                                    <label class="form-label mb-1">Custom 1</label>
			                                                    <span class="float-end" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Pubbica su quale sito"><i class="far fa-info-circle text-primary"></i></span>
			                                                    <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="Custom 1" v-model="contenuto.CUSTOM_1">
			                                                </div>
			                                                <div class="col-12 col-md-12 mb-2">
			                                                    <label class="form-label mb-1">Custom 2</label>
			                                                    <span class="float-end" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Pubbica su quale sito"><i class="far fa-info-circle text-primary"></i></span>													
			                                                    <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="Custom 2" v-model="contenuto.CUSTOM_2">
			
			                                                </div>
			
			                                                <div class="col-12 col-md-6 mb-2">
			                                                    <label class="custom-control custom-control-right">In Evidenza  </label>
			                                                    <span class="float-end" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Pubbica su quale sito"><i class="far fa-info-circle text-primary"></i></span>
			                                                    <select class="form-select form-contselectrol-sm" v-model="contenuto.FLG_INHOME" :tabindex="27">
			                                                        <option value="">Seleziona</option>
			                                                        <option v-bind:value="1"> &nbsp; Si</option>        
			                                                        <option v-bind:value="0"> &nbsp; No</option>        
			                                                    </select>
			                                                </div>
			                                                <div class="col-12 col-md-6 mb-2">
			                                                    <label class="custom-control custom-control-right">Counter</label>
			                                                    <span class="float-end" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Pubbica su quale sito"><i class="far fa-info-circle text-primary"></i></span>
			                                                    <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="Custom 2" v-model="contenuto.COUNTER">
			                                                </div>
			
			                                                <div class="col-12 col-md-6 mb-2">
			                                                    <label class="custom-control custom-control-right">Visibile </label>
			                                                    <span class="float-end" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Pubbica su quale sito"><i class="far fa-info-circle text-primary"></i></span>
			                                                    <select class="form-select form-select-sm" v-model="contenuto.FLG_VISIBILE" :tabindex="27">
			                                                        <option value="">Seleziona</option>
			                                                        <option v-bind:value="1"> &nbsp; Pubblico</option>        
			                                                        <option v-bind:value="0"> &nbsp; Admin</option>        
			                                                    </select>
			                                                </div>
			                                                <div class="col-12 col-md-6 mb-2">
			                                                    <label class="custom-control text-danger custom-control-right">Stato </label>
			                                                    <span class="float-end" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Pubbica su quale sito"><i class="far fa-info-circle text-primary"></i></span>
			                                                    <select class="form-select form-select-sm" data-placeholder="Stato" :tabindex="13" v-model="contenutoLangSelezionato.FLG_ATTIVO">
			                                                        <option value="">Seleziona</option>
																	<option value="1"> &nbsp; Attivata</option>
			                                                        <option value="0"> &nbsp; Disattivata</option>
			                                                    </select>
			                                                </div>
			                                            </div>
			
			                                        </div>
			                                    </div>
			                                </div>
			
			                            </div>
			
			                            <div v-if="modalita == 2" class="tab-pane fade active show" id="cont-main-cat" role="tabpanel">                                
			                                <h5 class="label-bar"><i class="fad fa-info-square fa-fw me-1"></i> Info Generali</h5>
			                                <div class="box_26">
			                                
			                                    <div class="row mt-1">
													<div class="col-6 col-md-3">
			                                            <label class="form-label text-danger mb-1">Modulo</label>	
			                                            <span class="float-end cursor-pointer" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Modello Contenuto"><i class="far fa-info-circle text-primary"></i></span>
			                                            <select class="form-select form-select-sm" v-model="categoriaSelezionata.FK_ID_MODULO">
			                                                <option value="">Seleziona modulo</option>
			                                                <option v-for="modulo in $root.arrayCategorieModuli" v-bind:key="modulo.ID_OPZIONE_TIPOLOGICA"  v-bind:value="modulo.ICONA" >{{modulo.DESCRIZIONE}}</option>
			                                            </select> 
			                                        </div>
			                                        <div class="col-6 col-md-3">
			                                            <label class="form-label text-danger mb-1"> Modello Contenuto </label>
			                                            <span class="float-end cursor-pointer" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Modello Contenuto"><i class="far fa-info-circle text-primary"></i></span>
			                                            <select class="form-select form-select-sm" v-model="categoriaSelezionata.FK_ID_MODELLO">
			                                                <option value="">Seleziona modello</option>
			                                                <option v-for="model in $root.arrayTipoContenuto" v-bind:key="model.ID_OPZIONE_TIPOLOGICA"  v-bind:value="model.ID_OPZIONE_TIPOLOGICA" >{{model.DESCRIZIONE}}</option>
			                                            </select> 
			                                        </div>
												</div>

												<div class="row mt-1">
			                                        <div class="col-12 mb-2">
			                                            <label class="form-label text-danger mb-1">Titolo:</label>
			                                            <div class="input-group">
															<span class="input-group-text"><i class="far fa-user fa-fw"></i></span>
															<input autocomplete="off" type="text" class="form-control form-control-sm valid" placeholder="Descrizione" v-model="categoriaSelezionata.DESCRIZIONE" :tabindex="4">
			                                            </div> 
			                                        </div>
												</div>
			
			                                    <div class="row mt-2">	
			                                        <div class="col-12 col-md-6">
			
			                                            <div class="row">
					                                        <div class="col-12 col-md-12 mb-2"> 
			                                                    <label class="form-label mb-1">Slogan:</label>
			                                                    <div class="input-group">
			                                                        <span class="input-group-text"><i class="far fa-user fa-fw"></i></span>
					                                                <input autocomplete="off" type="text" class="form-control form-control-sm" v-model="contenutoLangSelezionato.SOTTOTITOLO" :tabindex="4">
			
			                                                    </div> 
					                                        </div>
			                                                <div class="col-md-12 mb-2">
			                                                    <label class="form-label text-danger mb-1">Visibile nel Modulo</label>
			                                                    <span class="float-end" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Tematiche associate"><i class="far fa-info-circle text-primary"></i></span>
			                                                    <Multiple v-bind:options="filters.toSelect2(arrayModuli,'ID_OPZIONE_TIPOLOGICA','DESCRIZIONE')" v-model="categoriaSelezionata.moduli"></Multiple>
			
			                                                </div>
			                                                <div class="col-md-12 mb-2">
																<label class="form-label text-danger mb-0">Pubblica sul Sito</label>
                                                                <span class="float-end" data-bs-popup="popover" data-bs-placement="left"  data-bs-original-title="Tematiche associate" data-bs-content="assss"><i class="far fa-info-circle text-primary"></i></span>
                                                                <div class="input-group input-group-sm" :tabindex="15">
                                                                    <span class="btn btn-light btn-sm" v-on:click="categoriaSelezionata.enti = filters.select2AddAll(categoriaSelezionata.enti,filters.toSelect2($root.arrayEnti,'ID_ENTE','LABEL'))">Tutti</span>
                                                                    <Multiple v-bind:options="filters.toSelect2($root.arrayEnti,'ID_ENTE','LABEL')" v-model="categoriaSelezionata.enti"></Multiple>
                                                                </div>
			                                                </div>  
			                                            </div>
			
			                                        </div>  
			                                        <div class="col-12 col-md-6" style="border-left: 1px solid #ddd;">
			                                            
			                                            <div class="row">
			                                                <div class="col-12 col-md-12 mb-2">
			                                                    <label class="form-label mb-1">Custom 1</label>
			                                                    <span class="float-end" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Pubbica su quale sito"><i class="far fa-info-circle text-primary"></i></span>
			                                                    <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="Custom 1" v-model="categoriaSelezionata.CUSTOM_1">
			                                                </div>
			                                                <div class="col-12 col-md-12 mb-2">
			                                                    <label class="form-label mb-1">Custom 2</label>
			                                                    <span class="float-end" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Pubbica su quale sito"><i class="far fa-info-circle text-primary"></i></span>													
			                                                    <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="Custom 2" v-model="categoriaSelezionata.CUSTOM_2">
			                                                </div>
			
			                                                <div class="col-12 col-md-6 mb-2">
			                                                    <label class="custom-control custom-control-right">In Evidenza  </label>
			                                                    <span class="float-end" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Pubbica su quale sito"><i class="far fa-info-circle text-primary"></i></span>
			                                                    <select class="form-select form-select-sm" v-model="categoriaSelezionata.FLG_INHOME" :tabindex="27">
			                                                        <option value="">Seleziona</option>
			                                                        <option value="1"> &nbsp; Si</option>        
			                                                        <option value="0"> &nbsp; No</option>        
			                                                    </select>
			                                                </div>
			                                                <div class="col-12 col-md-6 mb-2">

															</div>
			                                                <div class="col-12 col-md-6 mb-2">
			                                                    <label class="custom-control custom-control-right">Visibile </label>
			                                                    <span class="float-end" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Pubbica su quale sito"><i class="far fa-info-circle text-primary"></i></span>
			                                                    <select class="form-select form-select-sm" v-model="categoriaSelezionata.FLG_VISIBILE" :tabindex="27">
			                                                        <option value="">Seleziona</option>
			                                                        <option value="1"> &nbsp; Pubblico</option>        
			                                                        <option value="0"> &nbsp; Admin</option>        
			                                                    </select>
			
			                                                </div>
			                                                <div class="col-12 col-md-6 mb-2">
			                                                    <label class="text-danger custom-control custom-control-right">Stato </label>
			                                                    <span class="float-end" data-bs-popup="popover" data-bs-placement="left" data-bs-content="Pubbica su quale sito"><i class="far fa-info-circle text-primary"></i></span>
			                                                    <select class="form-select form-select-sm" data-placeholder="Stato" :tabindex="13" v-model="categoriaSelezionata.FLG_ATTIVO">  
			                                                        <option value="1"> &nbsp; Attivata</option>
			                                                        <option value="0"> &nbsp; Disattivata</option>
			                                                    </select>
			                                                </div>
			                                            </div>
			                                        </div>
			
			                                    </div>
			                                </div>
			                            </div>
			
						                <div class="tab-pane fade" id="cont-seo" role="tabpanel">
			                                <h5 class="label-bar"><i class="fad fa-globe fa-fw me-1"></i> Configurazioni Seo</h5>
			                                <div class="box_26">
			                                    
			                                    <Seo v-model="contenutoLangSelezionato"></Seo>
			                                            
			                                </div>
			                            </div>
			
								    </div>	 
			                    </div>
							</div>
						</div>
				   	</div> 

                </div> 
                <div class="modal-footer bg-light p-1">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
						<i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
					</button>
                    <button class="btn btn-secondary float-end" v-on:click="salvaContenuto()"><i class="fal fa-save fa-fw me-1"></i> Salva Modifiche </button>                                  
                </div>
            </div>
        </div>
    </div>
				   

    <AvatarUploader ref="avatarUpd" folder="CONTENUTO" title="Immagine Contenuto" :modalId="'popUpUploadAvatarContenuto' + rs" @uploaded="onAvatarUploaded"></AvatarUploader>
    		  

</template>



<script>

import AvatarUploader from '@/components/utils/AvatarUploader.vue'
import Seo from '@/components/utils/Seo.vue'
import Multiple from '@/components/utils/Multiple.vue'


export default {
    name:"SchedaContenuto",
    emits:["updateGriglia"],
    props:["modulo","soloManuale","showPrincipale","modalita","currentLang","elencoContenuti"],
    components:{
        AvatarUploader,
        Seo,
        Multiple
    },
    data:function(){
        return {
            filters:global.filters,	 
            contenuto:{lang:{}},
            categoriaSelezionata:{enti:new Array()},
            contenutoLangSelezionato:{},
            arrayCategorie : new Array(),
            arrayModuli : new Array(),
			rs : utils.generateRandomString(30),
        }
    },

    methods: {
        startup : function(item){          
            this.filters.openPopUp('popUpContenuto'+this.rs);
			global.filters.popover();
            if (this.modalita == 1){
                document.getElementById("cont-main-tab").click();
                if (item.ID_CONTENUTO > 0){
                    utils.get("shared/contenuti/singolo",{ID_CONTENUTO:item.ID_CONTENUTO,LANG:this.idLinguaSelezionata}, (response) => {
                        if (response.esito == 0){
                            this.contenuto = response.data;
                            this.selezionaLang();
                        }                       
                    });            
                }     
                else{
                    this.contenuto = utils.clone(item);
					this.contenuto.FLG_VISIBILE = this.contenuto.FLG_VISIBILE == undefined ? '' : this.contenuto.FLG_VISIBILE;
					this.contenuto.FLG_INHOME = this.contenuto.FLG_INHOME == undefined ? '' : this.contenuto.FLG_INHOME;
					this.contenuto.FK_ID_MODELLO = this.contenuto.FK_ID_MODELLO == undefined ? '' : this.contenuto.FK_ID_MODELLO;

					if (this.contenuto.categorie == undefined){
						this.contenuto.categorie = [];
					}
                    this.contenutoLangSelezionato = {FLG_ATTIVO:1};
                }
            } 
            else{
                document.getElementById("cont-main-cat-tab").click(); 
                if (item.ID_CATEGORIA > 0){
                    utils.ajax('shared/categorie/singola',item, (response) => {
                        this.categoriaSelezionata = utils.clone(response.data);
                        utils.get("shared/contenuti/singolo",{ID_CONTENUTO:this.categoriaSelezionata.FK_ID_CONTENUTO,LANG:this.idLinguaSelezionata}, (response) => {
                            if (response.esito == 0){
                                this.contenuto = response.data;
                                this.selezionaLang();
                            }
                        });    
                    }); 
                }
                else{
                    this.categoriaSelezionata = utils.clone(item);
					this.categoriaSelezionata.FK_ID_MODELLO = this.categoriaSelezionata.FK_ID_MODELLO == undefined ? '' : this.categoriaSelezionata.FK_ID_MODELLO;
					this.categoriaSelezionata.FK_ID_MODULO = this.categoriaSelezionata.FK_ID_MODULO == undefined ? '' : this.categoriaSelezionata.FK_ID_MODULO;
					this.categoriaSelezionata.FLG_VISIBILE = this.categoriaSelezionata.FLG_VISIBILE == undefined ? '' : this.categoriaSelezionata.FLG_VISIBILE;
					this.categoriaSelezionata.FLG_INHOME = this.categoriaSelezionata.FLG_INHOME == undefined ? '' : this.categoriaSelezionata.FLG_INHOME;

                    this.contenuto = {ID_CONTENUTO:0,FK_ID_MODULO:0};
                }
            }                    
            utils.wait(()=>{
            });
        },	

        selezionaLang : function(){
            for (var i = 0 ; i < this.contenuto.langs.length ; i++){
                if (this.contenuto.langs[i].FK_ID_LINGUA == this.idLinguaSelezionata){
                    this.contenutoLangSelezionato = this.contenuto.langs[i];
                    break;
                }
            }
        }, 

        salvaContenuto(){
            if (this.modalita == 2){
                if (!this.categoriaSelezionata.FK_ID_MODELLO || this.categoriaSelezionata.FK_ID_MODELLO == 0){
                    utils.alert.warning('Il modello contenuto è obbligatorio');
                    return;
                }
                if (!this.categoriaSelezionata.FK_ID_MODULO || this.categoriaSelezionata.FK_ID_MODULO == 0){
                    utils.alert.warning('Il modulo è obbligatorio');
                    return;
                }
                if (!this.categoriaSelezionata.DESCRIZIONE || !this.categoriaSelezionata.DESCRIZIONE.trim()){
                    utils.alert.warning('Il titolo è obbligatorio');
                    return;
                }
                if (!this.categoriaSelezionata.moduli || this.categoriaSelezionata.moduli.length == 0){
                    utils.alert.warning('Selezionare almeno un modulo in "Visibile nel Modulo"');
                    return;
                }
                if (!this.categoriaSelezionata.enti || this.categoriaSelezionata.enti.length == 0){
                    utils.alert.warning('Selezionare almeno un ente in "Pubblica sul Sito"');
                    return;
                }
                if (this.categoriaSelezionata.FLG_ATTIVO === undefined || this.categoriaSelezionata.FLG_ATTIVO === '' || this.categoriaSelezionata.FLG_ATTIVO === null){
                    utils.alert.warning('Lo stato è obbligatorio');
                    return;
                }
                var api = this.categoriaSelezionata.ID_CATEGORIA > 0 ? "shared/categoria/update" : "shared/categoria/insert";
                utils.ajax(api,this.categoriaSelezionata, (response) => {
                    if (response.esito == 0){
                        utils.alert.success(response.messaggio);
						this.contenutoLangSelezionato.TITOLO = this.categoriaSelezionata.DESCRIZIONE;
                        if (this.categoriaSelezionata.ID_CATEGORIA == 0){
                            this.categoriaSelezionata.ID_CATEGORIA = response.id_inserito;
                            utils.ajax('shared/categorie/singola',this.categoriaSelezionata, (response) => {
                                this.categoriaSelezionata = response.data;
                                this.contenuto = utils.clone(this.categoriaSelezionata.contenuto);
                                for (var i = 0 ; i < this.contenuto.langs.length ; i++){
                                    if (this.contenuto.langs[i].FK_ID_LINGUA == this.idLinguaSelezionata){
                                        this.contenutoLangSelezionato.ID_CONTENUTO_LANG = this.contenuto.langs[i].ID_CONTENUTO_LANG;
                                        this.contenutoLangSelezionato.FK_ID_CONTENUTO = this.contenuto.langs[i].FK_ID_CONTENUTO;
                                        break;
                                    }
                                }
                                this.salvaContenutoLang();
                            });
                        }
                        else{
                            this.salvaContenutoLang();
                        }
                    }
                });
            }
            else{
                if (this.soloManuale && this.contenuto.ID_CONTENUTO == 0){
                    if (!this.contenuto.FK_ID_MODULO || this.contenuto.FK_ID_MODULO == '' || this.contenuto.FK_ID_MODULO == 0){
                        utils.alert.warning('Seleziona il modulo.');
                        return;
                    }
                    var principaleCreato = Number(this.categoriaPrincipale);
                    if (principaleCreato > 0){
                        var compatibile = this.arrayCategoriePrincipali.some((cat) => cat.ID_CATEGORIA == principaleCreato);
                        if (!compatibile){
                            utils.alert.warning('Seleziona una categoria compatibile con il modulo.');
                            return;
                        }
                    }
                }
                if (this.soloManuale){
                    if (!this.contenuto.categorie || this.contenuto.categorie.filter((id) => Number(id) > 0).length == 0){
                        utils.alert.warning('Seleziona almeno una categoria.');
                        return;
                    }
                }
                else{
                    if ((!this.contenuto.categorie || this.contenuto.categorie.length == 0 || this.contenuto.categorie[0] == 0)){
                        utils.alert.warning('La categoria è obbligatoria');
                        return;
                    }
                }
                if (this.modulo == 30 && this.elencoContenuti){
                    var categoriaGiaUsata = this.elencoContenuti.some((c) => {
                        return c.ID_CONTENUTO != this.contenuto.ID_CONTENUTO &&
                               c.CATEGORIE.some((cat) => cat.FK_ID_CATEGORIA == this.contenuto.categorie[0]);
                    });
                    if (categoriaGiaUsata){
                        utils.alert.warning('Esiste già un contenuto associato a questa categoria');
                        return;
                    }
                }
                if (!this.contenuto.FK_ID_MODELLO || this.contenuto.FK_ID_MODELLO == 0){
                    utils.alert.warning('Il modello contenuto è obbligatorio');
                    return;
                }
                if (!this.contenutoLangSelezionato.TITOLO || !this.contenutoLangSelezionato.TITOLO.trim()){
                    utils.alert.warning('Il titolo è obbligatorio');
                    return;
                }
                if (!this.contenuto.enti || this.contenuto.enti.length == 0){
                    utils.alert.warning('Selezionare almeno un ente in "Pubblica sul Sito"');
                    return;
                }
                if (this.contenutoLangSelezionato.FLG_ATTIVO === undefined || this.contenutoLangSelezionato.FLG_ATTIVO === '' || this.contenutoLangSelezionato.FLG_ATTIVO === null){
                    utils.alert.warning('Lo stato è obbligatorio');
                    return;
                }
                this.salvaContenutoLang();
            }
        },

        salvaContenutoLang(){
            if (this.contenuto.ID_CONTENUTO == 0){
                utils.ajax("shared/contenuto/insert",this.contenuto, (response) => {
                    if (response.esito == 0){
                        utils.alert.success(response.messaggio);
                        this.contenuto.ID_CONTENUTO = response.id_inserito;
                        this.contenutoLangSelezionato.FK_ID_CONTENUTO = response.id_inserito;
                        this.contenutoLangSelezionato.categorie = utils.clone(this.contenuto.categorie);
                        utils.get("shared/contenuti/singolo",{ID_CONTENUTO:this.contenuto.ID_CONTENUTO,LANG:this.idLinguaSelezionata}, (response) => {
                            this.contenuto.langs = response.data.langs;
                            if (response.esito == 0){                                
                                for (var i = 0 ; i < this.contenuto.langs.length ; i++){
                                    if (this.contenuto.langs[i].FK_ID_LINGUA == this.idLinguaSelezionata){
                                        this.contenutoLangSelezionato.ID_CONTENUTO_LANG = this.contenuto.langs[i].ID_CONTENUTO_LANG;
                                        utils.put("shared/contenuti/lang/update",this.contenutoLangSelezionato, (response) => {
                                            if (response.esito == 0){
                                                utils.alert.success(response.messaggio)                                        ;
                                            }
                                        }); 
                                        this.$emit("updateGriglia");
                                        break;
                                    }
                                }
                            }
                        });                        
                    }
                });     
            }
            else{
                this.contenutoLangSelezionato.categorie = utils.clone(this.contenuto.categorie);
                utils.put("shared/contenuti/lang/update",this.contenutoLangSelezionato, (response) => {
                    utils.ajax("shared/contenuto/update",this.contenuto,(response)=>{
                        if (response.esito == 0){
                            utils.alert.success(response.messaggio);
                            this.$emit("updateGriglia");
                        }
                    });
                }); 
            }
        }, 	

        openUploadContenuto : function(contenuto){
            this.$refs.avatarUpd.open({id: contenuto.ID_CONTENUTO, url: contenuto.URL_AVATAR});
        },

        onAvatarUploaded : function(nomeAvatar){
            this.contenuto.URL_AVATAR = nomeAvatar;
            utils.get("shared/contenuti/singolo",{ID_CONTENUTO:this.contenuto.ID_CONTENUTO,LANG:this.idLinguaSelezionata}, (response) => {
                if (response.esito == 0 && response.data){
                    this.contenuto = response.data;
                    this.selezionaLang();
                }
            });
        },
    
    },

	computed:{
		idLinguaSelezionata(){
			return this.currentLang || this.$root.currentLang;
		},

		arrayModuliOperativi(){
			if (!this.$root.arrayTipoModuli){
				return [];
			}
			return this.$root.arrayTipoModuli.filter((modulo) => modulo.FLG_HELP != 1);
		},

		moduloOperativoLabel(){
			if (!this.contenuto.FK_ID_MODULO || !this.$root.arrayTipoModuli){
				return '';
			}
			var modulo = utils.array.select(this.$root.arrayTipoModuli,'ICONA',this.contenuto.FK_ID_MODULO,1)[0];
			return modulo ? modulo.DESCRIZIONE : '';
		},

		arrayCategorieKB(){
			return this.arrayCategorie.filter((cat) => cat.FLG_KB == 1);
		},

		arrayCategoriePrincipali(){
			if (!this.soloManuale){
				return this.arrayCategorieSelezionabili;
			}
			if (this.contenuto.ID_CONTENUTO > 0){
				return this.arrayCategorieKB;
			}
			var ic = this.contenuto.FK_ID_MODULO;
			var icStr = String(ic === undefined || ic === null ? '' : ic);
			if (!icStr){
				return [];
			}
			return this.arrayCategorieKB.filter((cat) => {
				var icone = String(cat.ICONE_MODULI || '').split(',').map((x) => x.trim()).filter(Boolean);
				return icone.indexOf(icStr) != -1;
			});
		},

		arrayCategorieAggiuntive(){
			var principale = Number(this.categoriaPrincipale);
			return this.arrayCategorieKB.filter((cat) => Number(cat.ID_CATEGORIA) != principale);
		},

		arrayCategorieSelezionabili(){
			if (this.modulo){
				return this.arrayCategorie.filter((cat) => cat.FK_ID_MODULO == this.modulo);
			}
			return utils.array.selectByModuloIcona(this.arrayCategorie,this.$root.arrayTipoModuli,this.$root.arrayIdCategorieModuli);
		},

		categoriaPrincipale:{
			get(){
				return (this.contenuto.categorie && this.contenuto.categorie.length > 0) ? this.contenuto.categorie[0] : 0;
			},
			set(val){
				var principale = Number(val);
				var aggiuntive = this.categorieAggiuntive.filter((id) => id != principale);
				this.contenuto.categorie = (principale > 0 ? [principale] : []).concat(aggiuntive);
				if (principale > 0){
					var cat = utils.array.select(this.arrayCategorie,'ID_CATEGORIA',principale,1)[0];
					if (cat){
						this.contenuto.FK_ID_MODELLO = cat.FK_ID_MODELLO;
					}
				}
			},
		},

		categorieAggiuntive:{
			get(){
				var arr = this.contenuto.categorie || [];
				return arr.slice(1).map(Number).filter((id) => id > 0);
			},
			set(val){
				var principale = Number(this.categoriaPrincipale);
				var ids = (val || []).map(Number).filter((id) => id > 0 && id != principale);
				this.contenuto.categorie = (principale > 0 ? [principale] : []).concat(ids);
			},
		},

		categoriaContenutoSelezionata:{
			get(){
				return (this.contenuto.categorie && this.contenuto.categorie.length > 0) ? this.contenuto.categorie[0] : 0;
			},
			set(val){
				this.contenuto.categorie = val > 0 ? [val] : [];
				if (val > 0){
					var cat = utils.array.select(this.arrayCategorie,'ID_CATEGORIA',val,1)[0];
					if (cat){
						this.contenuto.FK_ID_MODELLO = cat.FK_ID_MODELLO;
					}
				}
			},
		}
	},

	watch:{
		'contenuto.FK_ID_MODULO': function(nuovo){
			if (this.soloManuale && this.contenuto.ID_CONTENUTO == 0){
				var categoriaCorrente = this.categoriaPrincipale;
				if (categoriaCorrente > 0){
					var compatibile = this.arrayCategoriePrincipali.some((cat) => cat.ID_CATEGORIA == categoriaCorrente);
					if (!compatibile){
						this.contenuto.categorie = [];
						this.contenuto.FK_ID_MODELLO = '';
					}
				}
			}
		},
	},

    created : function(){
        this.arrayModuli = this.$root.arrayTipoModuli;
        utils.get("shared/categorie/modulo",{}, (response) => {
            this.arrayCategorie = response.data;
            this.azienda = response.data;
        },false);
    }
}
</script>

